export default __webpack_public_path__ + "static/media/fix-recruiting.aaadc593.svg";